import { HttpModelConverter } from "src/app/modules/core/converter/httpModel.converter";
import { MedicalToolSetSummaryModel } from "../medicalToolSetSummary.model";
import { Injectable } from '@angular/core';
import { PermissionsConverter } from "src/app/modules/common/converter/permissions.converter";
import {PartnerSummaryConverter} from "../../../../../../partner/common/api/converter/partnerSummary.converter";
import {DateConverter} from "../../../../../../common/converter/date.converter";
import {UserSummaryConverter} from "../../../../../../account/modules/user/api/converter/userSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class MedicalToolSetSummaryConverter extends HttpModelConverter<MedicalToolSetSummaryModel> {
    constructor(private permissionsConverter: PermissionsConverter,
                private partnerSummaryConverter: PartnerSummaryConverter,
                private dateConverter: DateConverter,
                private userSummaryConverter: UserSummaryConverter) {
        super();
    }
    protected createInstance(): MedicalToolSetSummaryModel {
        return new MedicalToolSetSummaryModel();
    }
    protected enrichObject(result: MedicalToolSetSummaryModel, src: MedicalToolSetSummaryModel) {
        result.permissions = this.permissionsConverter.convert(src.permissions);
        result.partner = this.partnerSummaryConverter.convert(src.partner);
        result.useDate = this.dateConverter.convert(src.useDate);
        result.validationDate = this.dateConverter.convert(src.validationDate);
        result.user = this.userSummaryConverter.convert(src.user);
    }
}

